
import { declareVrunComponent } from '/vodalys/vvuejs/declareVrunComponent.mjs'

declareVrunComponent('captionMain2.vrun.component', () => import('./CaptionMain2.vue'))
